<template>
  <NavTopBar/>
  <SldHomeTopSearch/>
  <div class="bottom_line"></div>
  <router-view></router-view>
  <FooterService/>
  <FooterLink/>
</template>

<script>
  import NavTopBar from "../../components/NavTopBar";
  import SldHomeTopSearch from "../../components/SldHomeTopSearch";
  import FooterService from "../../components/FooterService";
  import FooterLink from "../../components/FooterLink";
export default {
  name: 'Cart',
  components: {
    NavTopBar,
    SldHomeTopSearch,
    FooterService,
    FooterLink,
  },
  setup() {
    const isRouterAlive = true
    return { isRouterAlive }
  }
}
</script>
